(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sqsh-collection-switcher"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  class SqshCollectionSwitcher extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      const { signal } = this.#controller;

      this.addEventListener('click', this.#handleSelect, { signal });

      // Theme editor: clicking a tab block in the sidebar opens its panel
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', this.#handleSelect, { signal });
      }
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    select(tab) {
      for (const item of this.querySelectorAll('.sqsh-collection-tab')) {
        const selected = item === tab;
        const panel = document.getElementById(item.getAttribute('aria-controls'));

        item.setAttribute('aria-expanded', String(selected));
        if (panel) panel.hidden = !selected;
      }
    }

    #handleSelect = (event) => {
      const tab = event.target.closest?.('.sqsh-collection-tab');
      if (tab && this.contains(tab)) this.select(tab);
    };
  }

  if (!customElements.get('sqsh-collection-switcher')) {
    customElements.define('sqsh-collection-switcher', SqshCollectionSwitcher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tagged-menu-column"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  (() => {
    if (customElements.get('sqsh-link-guard')) return;

    class SqshLinkGuard extends HTMLElement {
      connectedCallback() {
        this.disableInteractive();
        this.observer = new MutationObserver(() => this.disableInteractive());
        this.observer.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      disableInteractive() {
        this.querySelectorAll('a[href]').forEach((link) => {
          link.dataset.sqshHref = link.getAttribute('href');
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
          link.tabIndex = -1;
        });
        this.querySelectorAll('button:not([disabled])').forEach((button) => {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
        });
      }
    }

    customElements.define('sqsh-link-guard', SqshLinkGuard);
  })();

  /** code by squarestylist.com — standoutshopify.com **/
  (() => {
    if (customElements.get('sqsh-equal-heights')) return;

    class SqshEqualHeights extends HTMLElement {
      connectedCallback() {
        // Fires on first paint, window resizes, and whenever content
        // (images, fonts) changes the section's size.
        this.observer = new ResizeObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.equalize());
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer.disconnect();
        cancelAnimationFrame(this.frame);
      }

      equalize() {
        const items = this.querySelectorAll('.sqsh-tag-menu__item');
        if (!items.length) return;

        // Release first so heights can shrink when the screen gets wider
        items.forEach((item) => (item.style.minHeight = ''));

        if (this.hasAttribute('data-sqsh-equal-heights-off')) return;

        // Single-column mobile layout: leave natural heights
        const columns = getComputedStyle(this).gridTemplateColumns.split(' ').length;
        if (columns < 2) return;

        let tallest = 0;
        items.forEach((item) => (tallest = Math.max(tallest, item.offsetHeight)));
        items.forEach((item) => (item.style.minHeight = tallest + 'px'));
      }
    }

    customElements.define('sqsh-equal-heights', SqshEqualHeights);
  })();

  } catch(e) { console.error(e); }
})();
})();
